import React, { useEffect, useState } from 'react';
import logo from '../../assets/img/profile/logo.png'; // Tell webpack this JS file uses this image

// chakra imports
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
  Image,
  Text,
} from '@chakra-ui/react';
import Content from 'components/sidebar/components/Content';
import {
  renderThumb,
  renderTrack,
  renderView,
  renderViewMini,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useJwt } from 'react-jwt';
import { getCookie } from 'cookies-next';
// Assets
import { IoMenuOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

function Sidebar(props: { routes: RoutesType[]; [x: string]: any }) {
  const [data1, setData1] = useState('admin');
  const [timbres, setTimbres] = useState({ usados: 0, restantes: 0 });

  const token = getCookie('token');
  const jwt = useJwt(token);
  const user = useSelector((state: RootState) => state.auth.user);

  let valores = JSON.stringify(jwt.decodedToken);
  let valoresx = JSON.parse(valores);
  useEffect(() => {
    // OBTENDRA EL TOKEN
    fetchData();
    fetchTimbres();
  }, []);

  const fetchTimbres = async () => {
    try {
      const response = await fetch(
        'http://52.91.130.91:5000/api/Facturacion/estatus-cuenta',
      );
      const data = await response.json();
      const { DetallesPaqueteCreditos } = data.ConsultarCreditosResult.Paquetes;

      // Asegúrate de que DetallesPaqueteCreditos es un array válido.
      if (Array.isArray(DetallesPaqueteCreditos)) {
        const totalTimbresUsados = DetallesPaqueteCreditos.reduce(
          (sum, paquete) => sum + (paquete.TimbresUsados || 0),
          0,
        );
        const totalTimbresRestantes = DetallesPaqueteCreditos.reduce(
          (sum, paquete) => sum + (paquete.TimbresRestantes || 0),
          0,
        );

        const totalTimbres = totalTimbresUsados + totalTimbresRestantes;
        setTimbres({
          usados: totalTimbresUsados,
          restantes: totalTimbresRestantes,
        });

        console.log('Total Timbres Usados:', totalTimbresUsados);
        console.log('Total Timbres Restantes:', totalTimbresRestantes);
        console.log('Total Timbres:', totalTimbres);
      } else {
        console.error('DetallesPaqueteCreditos no es un array válido.');
      }
    } catch (error) {
      console.error('Error fetching timbres:', error);
    }
  };
  const fetchData = async () => {
    try {
      valores = JSON.stringify(jwt.decodedToken);
      valoresx = await JSON.parse(valores);
      setData1(valoresx.tipo);
    } catch (error) {
      // console.error('Error fetching data:', error);
    }
  };
  const { routes, mini, hovered, setHovered } = props;

  // this is for the rest of the collapses
  let variantChange = '0.2s linear';
  let shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
    'unset',
  );
  // Chakra Color Mode
  let sidebarBg = useColorModeValue('white', 'navy.800');
  let sidebarRadius = '30px';
  let sidebarMargins = '0px';

  let tipo = 'admin';

  // SIDEBAR

  //AQUI OBTENER PERMISOS!! 140424

  // console.log(data1)
  let routex = routes.filter(
    (r) => r.path == '/dashboards' || r.path == '/main',
  );
  if (data1 == 'mortal') routex = routes.filter((r) => r.path == '/main');
  if (data1 == 'admin') routex = routes;
  if (tipo == 'comitiva') routex = routes.filter((r) => r.path == '/' + tipo);

  // routex.map((x) => {
  //   console.log(x);
  // })

  return (
    data1 && (
      <Box
        display={{ base: 'block', sm: 'none', xl: 'block' }} // Mostrar en todas las pantallas, excepto donde no aplica
        position="fixed"
        h="100vh"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Box
          bg={sidebarBg}
          transition={variantChange}
          w={mini ? (hovered ? '280px' : '120px') : '280px'}
          h="calc(100vh - 32px)"
          m={sidebarMargins}
          borderRadius={sidebarRadius}
          boxShadow={shadow}
          overflow="hidden"
          display="flex"
          flexDirection="column"
        >
          {/* Contenedor del logotipo */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py="20px"
            bg={sidebarBg}
            flexShrink={0} // Evita que este contenedor se reduzca
            minH="150px" // Altura mínima asegurada para el logotipo
          >
            {/* Logotipo adaptable */}
            <Image
              h={{ base: '50px', sm: '70px', md: '100px' }}
              w={{ base: '50px', sm: '70px', md: '100px' }}
              maxW="244px"
              src={logo}
              alt="TECNO INNOVA"
            />
            {/* Texto debajo del logotipo */}
            {user?.rol == 'A1' && (

            <Text
              mt="8px"
              fontSize={{ base: 'xs', sm: 'sm' }}
              color="gray.600"
              textAlign="center"
            >
              Timbres usados: {timbres.usados} Restantes: {timbres.restantes}
            </Text>)}
          </Box>
  
          {/* Scrollable Content */}
          <Scrollbars
            style={{
              height: 'calc(100vh - 150px)', // Ajustar la altura según el espacio restante
            }}
            autoHide
            renderTrackVertical={renderTrack}
            renderThumbVertical={renderThumb}
            renderView={mini ? (hovered ? renderView : renderViewMini) : renderView}
          >
            <Content mini={mini} hovered={hovered} routes={routex} />
          </Scrollbars>
        </Box>
      </Box>
    )
  );
  
}

// FUNCTIONS
export function SidebarResponsive(props: {
  routes: RoutesType[];
  [x: string]: any;
}) {
  let sidebarBackgroundColor = useColorModeValue('white', 'navy.800');
  let menuColor = useColorModeValue('gray.400', 'white');
  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const { routes } = props;
  // let isWindows = navigator.platform.startsWith("Win");
  //  BRAND

  return (
    <Flex display={{ sm: 'flex', xl: 'none' }} alignItems="center">
      <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: 'pointer' }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent
          w="285px"
          maxW="285px"
          ms={{
            sm: '16px',
          }}
          my={{
            sm: '16px',
          }}
          borderRadius="16px"
          bg={sidebarBackgroundColor}
        >
          <DrawerCloseButton
            zIndex="3"
            onClick={onClose}
            _focus={{ boxShadow: 'none' }}
            _hover={{ boxShadow: 'none' }}
          />
          <DrawerBody maxW="285px" px="0rem" pb="0">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content mini={false} routes={routes} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

export default Sidebar;
